import { z } from 'zod';

export const FlagDTO = z.object({
    id: z.string().optional(),
    label: z.string().optional(),
    endDate: z.string().optional(),
});

export type FlagDTO = z.infer<typeof FlagDTO>;
